import { checkTokenExpiry } from "./apiClient";
import { getCookie } from "./cookies";
import { fetchNewToken } from "./fetchNewToken";
import { jwtDecode } from "./jwtDecode";

type UserType = {
    email: string,
    firstName: string,
    lastName: string,
    organisationId: number,
    roles: string,
    permission: string[],
    organizationName: string,
    organizationUniqueID: number,
    sub: string,
    iat: number,
    exp: number
}

export const getCurrentUser = async (): Promise<UserType | null> => {
    let token = getCookie('user');
    if (!token) return null;

    const payload = jwtDecode(token);
    if (checkTokenExpiry(payload.exp)) {
        await fetchNewToken();
        return await getCurrentUser();
    }

    return payload;
}